import openDatabase from "../../IndexedDB/openDatabase";

const readListUIStateFromIndexedDB = async (
  persistKey,
  dbName = "ERP_DB",
  storeName = "List_Ui_State",
  dbVersion = 1,
) => {
  try {
    // Open the database and object store
    const db = await openDatabase(dbName, storeName, dbVersion);
    if (!db.objectStoreNames.contains(storeName)) {
      return null;
    }
    return new Promise((resolve) => {
      const transaction = db.transaction(storeName, "readonly");
      const store = transaction.objectStore(storeName);

      const request = store.get(persistKey);

      request.onsuccess = () => {
        resolve(request.result || null);
      };

      request.onerror = () => {
        resolve(null);
      };
    });
  } catch (error) {
    console.error("Error reading List UI State:", error);
    return null;
  }
};
export default readListUIStateFromIndexedDB;
